import React from 'react';
import { motion } from 'framer-motion';
import {
  LayoutDashboard,
  MessageSquare,
  Monitor,
  Smartphone,
  Settings,
  Zap,
  QrCode,
  Sparkles,
  ScanLine,
  Server,
  Network,
  Brain,
  Database,
  Puzzle,
  CheckCircle,
  BarChart3,
  Wallet,
  Cpu,
  Key,
  Play,
  Mail,
  UserCircle,
  Gift,
  Wrench,
  ScrollText,
  Users,
  Send,
  Layers,
  Euro,
  Shield,
  Palette,
  Share2,
  FileText,
  CreditCard,
  Home,
  Heart,
  GitBranch,
  HardDrive,
  LayoutGrid,
  Calendar,
  Folder,
  Eye,
  Terminal,
  Globe,
  LogOut,
  Bot,
  LayoutDashboard as BotDashboard,
  Workflow,
  ScanSearch,
  FlaskConical,
  Crosshair,
  Activity,
} from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const menuGroups = [
  {
    label: 'Finans Protect & Automation',
    items: [
      { id: 'openbalancer', name: 'OpenBalancer Control Panel', icon: Zap },
      { id: 'finansprotect', name: 'Finans Protect Hub', icon: Shield },
      { id: 'wallesterdash', name: 'Dashboard', icon: BarChart3 },
      { id: 'eligibility', name: 'Eligibility Check', icon: CheckCircle },
      { id: 'signupflow', name: 'Signup Flow', icon: Play },
      { id: 'verification', name: 'Verification', icon: Mail },
      { id: 'adminpayouts', name: 'Payout Queue', icon: Wallet },
      { id: 'credentialvault', name: 'Credential Vault', icon: Key },
      { id: 'partners', name: 'Partners', icon: Users },
      { id: 'alternatives', name: 'Alternatives', icon: Gift },
      { id: 'actionlog', name: 'Action Log', icon: ScrollText },
      { id: 'wallesterapi', name: 'API & Cards', icon: CreditCard },
      { id: 'systemconfig', name: 'Config', icon: Wrench },
    ],
  },
  {
    label: 'Marketing',
    items: [
      { id: 'aicreatives', name: 'AI Creatives', icon: Palette },
      { id: 'socialautomation', name: 'Social Media', icon: Share2 },
      { id: 'currency', name: 'Currency & Invest', icon: Euro },
      { id: 'landing', name: 'Landing Page', icon: Home },
    ],
  },
  {
    label: 'AI Tools',
    items: [
      { id: 'dashboard', name: 'Overview', icon: LayoutDashboard },
      { id: 'chat', name: 'Claude Chat', icon: MessageSquare },
      { id: 'computer', name: 'Computer Use', icon: Monitor },
      { id: 'android', name: 'Android Control', icon: Smartphone },
      { id: 'qrscanner', name: 'QR Scanner', icon: QrCode },
      { id: 'smartscan', name: 'Smart Scan', icon: ScanLine },
      { id: 'promptgen', name: 'Prompt Generator', icon: Sparkles },
      { id: 'noteanalyzer', name: 'Note Analyzer', icon: FileText },
    ],
  },
  {
    label: 'Infrastructure',
    items: [
      { id: 'openbalancer', name: 'OpenBalancer LB', icon: Zap },
      { id: 'kimik3', name: 'Kimi K3 Agent', icon: Cpu },
      { id: 'hermesgateways', name: 'Hermes Gateways', icon: Cpu },
      { id: 'telegramhub', name: 'Telegram Hub & Bots', icon: Send },
      { id: 'obsidianmemories', name: 'Obsidian Memories', icon: Brain },
      { id: 'containervault', name: 'Container Vault', icon: HardDrive },
      { id: 'orchestration', name: 'Orchestration', icon: Network },
      { id: 'multiagent', name: 'Multi-Agent', icon: Brain },
      { id: 'agentregistry', name: 'Agent Registry', icon: Database },
      { id: 'extensions', name: 'Brave Extensions', icon: Puzzle },
      { id: 'telegramextractor', name: 'TG Extractor', icon: Send },
      { id: 'platformcatalog', name: 'Platform Catalog', icon: Layers },
      { id: 'security', name: 'Security', icon: Shield },
      { id: 'filedashboard', name: 'File Manager', icon: HardDrive },
      { id: 'githubecosystem', name: 'Ecosystem Vault', icon: GitBranch },
      { id: 'fleetbalancer', name: 'Resource Balancer', icon: Activity },
      { id: 'tailnetdevices', name: 'Hardware & Tailnet', icon: Network },
    ],
  },
  {
    label: 'Browser Automation',
    items: [
      { id: 'automation-dashboard', name: 'Overview', icon: Bot },
      { id: 'automation-sessions', name: 'Sessions', icon: Globe },
      { id: 'automation-taskbuilder', name: 'Task Builder', icon: Workflow },
      { id: 'automation-analyzer', name: 'Page Analyzer', icon: ScanSearch },
      { id: 'automation-monitor', name: 'Monitor', icon: Crosshair },
      { id: 'automation-sandbox', name: 'Sandbox', icon: FlaskConical },
    ],
  },
  {
    label: 'Hermes Agent System',
    items: [
      { id: 'hermesgateways', name: 'Hermes Gateways', icon: Cpu },
      { id: 'hermeshub', name: 'Hermes Hub', icon: Brain },
      { id: 'obsidianmemories', name: 'Obsidian Memories', icon: FileText },
      { id: 'telegramhub', name: 'Telegram Hub & Bots', icon: Send },
    ],
  },
  {
    label: 'Linked Nodes',
    items: [
      { id: 'openbalancer', name: 'Open Balancer (macmini)', icon: Server },
      { id: 'hermeshub', name: 'Hermes Hub', icon: Brain },
      { id: 'ext-infisical', name: 'Infisical Vault', icon: Key },
    ],
  },
  {
    label: 'Personal',
    items: [
      { id: 'personaldev', name: 'Development', icon: Heart },
      { id: 'changelog', name: 'Project Progress', icon: GitBranch },
    ],
  },
  {
    label: null,
    items: [
      { id: 'settings', name: 'Settings', icon: Settings },
    ],
  },
];

export default function Sidebar({ activePage, setActivePage, isOpen, setIsOpen }) {
  const { signOut } = useAuth();

  return (
    <>
      {/* Backdrop Overlay for Narrow / Mobile Windows */}
      {isOpen && (
        <div
          onClick={() => setIsOpen(false)}
          className="fixed inset-0 bg-black/70 backdrop-blur-md z-40 lg:hidden transition-opacity"
          aria-hidden="true"
        />
      )}

      <motion.aside
        initial={false}
        animate={{
          width: isOpen ? '16rem' : '5rem',
        }}
        className={`
          fixed left-0 top-0 h-screen glass-effect border-r border-white/10 z-50
          flex flex-col justify-between overflow-hidden transition-all duration-300
          ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        `}
      >
        {/* Header & Logo */}
        <div className="p-4 sm:p-5 flex-shrink-0">
          <div className="flex items-center gap-3 mb-4">
            <div className="w-10 h-10 bg-gradient-to-br from-primary-500 to-primary-600 rounded-lg flex items-center justify-center shrink-0 shadow-lg shadow-primary-500/20">
              <Zap className="w-6 h-6 text-white" />
            </div>
            {isOpen && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.1 }}
                className="min-w-0"
              >
                <h1 className="text-lg font-bold bg-gradient-to-r from-cyan-400 via-primary-500 to-emerald-400 bg-clip-text text-transparent truncate">
                  Open Balancer
                </h1>
                <p className="text-[11px] text-gray-400 font-medium truncate">Finans Protect Engine</p>
              </motion.div>
            )}
          </div>
        </div>

        {/* Scrollable Navigation Menu (with pb-12 to prevent bottom item overlap) */}
        <div className="flex-1 overflow-y-auto px-3 custom-scrollbar min-h-0 space-y-1 pb-12">
          <nav aria-label="Main Navigation">
            {menuGroups.map((group, gi) => (
              <div key={gi} className={group.label ? 'mb-2' : ''}>
                {group.label && isOpen && (
                  <p className="text-[10px] font-bold text-gray-400 uppercase tracking-wider px-3 mb-1 mt-2">
                    {group.label}
                  </p>
                )}
                {!isOpen && group.label && <div className="border-t border-white/5 my-2 mx-2"></div>}
                {group.items.map((item) => {
                  const Icon = item.icon;
                  const isActive = activePage === item.id;

                  return (
                    <motion.button
                      key={item.id}
                      onClick={() => {
                        setActivePage(item.id);
                        if (typeof window !== 'undefined' && window.innerWidth < 1024) {
                          setIsOpen(false);
                        }
                      }}
                      aria-current={isActive ? 'page' : undefined}
                      aria-label={item.name}
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      className={`
                        w-full flex items-center gap-3 px-3 py-2 rounded-lg
                        transition-all duration-200 relative overflow-hidden focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500
                        ${isActive
                          ? 'bg-gradient-to-r from-primary-500 to-primary-600 text-white shadow-md shadow-primary-500/30 font-semibold'
                          : 'text-gray-300 hover:text-white hover:bg-white/5'
                        }
                      `}
                    >
                      {isActive && (
                        <motion.div
                          layoutId="activeTab"
                          className="absolute inset-0 bg-gradient-to-r from-primary-500 to-primary-600"
                          transition={{ type: 'spring', bounce: 0.2, duration: 0.6 }}
                        />
                      )}

                      <Icon className="w-4 h-4 sm:w-4.5 sm:h-4.5 relative z-10 flex-shrink-0" />

                      {isOpen && (
                        <motion.span
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1 }}
                          className="relative z-10 font-medium text-xs truncate"
                        >
                          {item.name}
                        </motion.span>
                      )}
                    </motion.button>
                  );
                })}
              </div>
            ))}
          </nav>
        </div>

        {/* Footer Area (Strictly Separated Flex Footer) */}
        <div className="p-3 flex-shrink-0 border-t border-white/10 space-y-2 bg-dark-950/90 z-20">
          <div className="glass-effect rounded-lg p-2 flex items-center justify-center">
            <div className="flex items-center gap-2">
              <div className="relative">
                <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                <div className="absolute inset-0 w-2 h-2 bg-green-500 rounded-full animate-ping opacity-75"></div>
              </div>
              {isOpen && (
                <motion.span
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  className="text-[10px] text-green-400 font-bold tracking-wide uppercase"
                >
                  Encrypted Link
                </motion.span>
              )}
            </div>
          </div>

          <button
            onClick={() => signOut()}
            className="w-full flex items-center justify-center gap-2 p-2 text-red-400 hover:text-white hover:bg-red-500/80 rounded-lg transition-all border border-red-500/20 hover:border-red-500 shadow-sm"
          >
            <LogOut className="w-4 h-4 shrink-0" />
            {isOpen && <span className="text-xs font-semibold tracking-wide">Disconnect</span>}
          </button>
        </div>
      </motion.aside>
    </>
  );
}
